import { enhanceNavigation, addRoomEntryPoints } from './pf-fusion-20260928-enhancements.js?v=a7a8b99cfded';
import { enhanceHomepage } from './pf-fusion-20260928-home-index.js?v=af3c3a8df66f1f187b861256a924982557d3cd6e2c3dc1fb6f173a00a55b1059';
import { recordPreviewEvent } from './pf-fusion-20260928-analytics.js?v=689e4b6737e4109fb7a91c46367f17aa67fce9f23dfc0663391b964cfcb216be';
import { enhanceStyleNavigation } from './pf-fusion-20260928-navigation-style-menu.js?v=8df103cf739f6fb908bef9b3481f333b81fd0fcab4f6f8aa880b7c79b425b21b';
import { enhanceBrowsePage } from './pf-fusion-20260928-catalogue-browse-page.js?v=fd63e8e311ecb56aa35c8929820fb8d166fa478a65cd8c833ec53f44be021279';

document.body.classList.add('pf-fusion');
document.body.dataset.fusionAppearance = 'light';
enhanceNavigation();
enhanceStyleNavigation().catch(() => { /* Original Shop links remain available. */ });
enhanceBrowsePage();
enhanceHomepage().catch(() => { /* Original homepage remains usable if enhancement cannot load. */ });
addRoomEntryPoints();
document.addEventListener('click', event => {
  const target = event.target.closest('a,button');
  if (!target) return;
  // Only store pre-defined UI labels and routes, never form values or uploads.
  if (target.matches('[data-fusion-custom]')) recordPreviewEvent('pf_fusion_custom_entry');
  if (target.matches('[data-cg-view]')) recordPreviewEvent('pf_fusion_catalogue_view', { view: target.dataset.cgView });
  if (target.matches('[data-cg-open-drawer]')) recordPreviewEvent('pf_fusion_filters_open');
});
